(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("natty-fetch"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom", "natty-fetch"], factory);
	else if(typeof exports === 'object')
		exports["RenderEngine"] = factory(require("react"), require("react-dom"), require("natty-fetch"));
	else
		root["RenderEngine"] = factory(root["React"], root["ReactDOM"], root["nattyFetch"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__15__, __WEBPACK_EXTERNAL_MODULE__23__) {
return 